import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateElement, ScreensQuestionResource } from '@Components/mras/core';
import { MatDatepicker } from '@angular/material/datepicker';
import _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { Moment} from 'moment';
import { FormControl } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { SharedModule } from '@Shared/shared.module';
import { MrasMaskDateDirective } from './mras-mask-date.directive';

const moment = _moment;
export const MY_FORMATS = {
    parse: {
        dateInput: ['YYYY-MM-DD', 'MM/DD/YYYY', 'MM-DD-YYYY']
    },
    display: {
        dateInput: 'MM/DD/YYYY',
        monthYearLabel: 'MM/DD/YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM DD YYYY',
    },
};
@Component({
    selector: 'jhi-date-input',
    templateUrl: './date-input.component.html', // This directive is not standalone, it should be used within an NgModule,
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    imports: [SharedModule, MrasMaskDateDirective]
})
export class DateInputComponent implements OnInit {
    @Input() question: ScreensQuestionResource;
    @Input()
        summaryMode: boolean;

    _value: string;
    formattedDate: string;
    
    @Input() set value(val: string) {
        if (!val || val === '') {
            this._value = null;
            this.formattedDate = null;
            this.dateValue.setValue(null);
            return;
        }

        const d = new Date(val);
        this.formattedDate = d.toISOString().substring(0, 10) + d.toISOString().substring(10,);          
        
        this._value = moment(val).format(this.dateFormat);
        this.dateValue.setValue(moment.utc(this.formattedDate));
    }
    get value() {return this._value;}
        
    @Output()
        valueChange = new EventEmitter<string>();
    @Input()
        granularity: DateElement;

    ngbMinDate: Date;
    ngbMaxDate: Date;

    @Input()
        placeholder: string;
    @Input()
        disabled: boolean;
    @Input()
        enableChangeButton: boolean;

    @Output()
        action = new EventEmitter();

    dateValue= new FormControl();

    @Input() set minDate(dateString: string) {
        if (dateString == null) {
            return;
        }
        const date = new Date(dateString);
        this.ngbMinDate = date;
    }

    @Input() set maxDate(dateString: string) {
        if (dateString == null) {
            return;
        }
        const date = new Date(dateString);
        this.ngbMaxDate = date;
    }

    dateFormat = "YYYY-MM-DD";

    pickerFieldName: string;

    ngOnInit(): void {
        if (this.granularity === DateElement.MONTH) {
            this.dateFormat = "YYYY-MM";
        }

        if (this.formattedDate != null) {    
            const newDate = new Date(this.formattedDate);        
            newDate.setDate( new Date(this.formattedDate).getDate() + 1);
            this.dateValue.setValue(moment.utc(this.formattedDate));
        }
    }

    setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {     
        this.dateValue.setValue(moment(normalizedMonthAndYear).format(this.dateFormat));
        this.onDateChange();
        datepicker.close();
    }

    onDateChange() {
        if (!this.summaryMode) {
            if (this.value && this.value !== '') {
                this.valueChange.emit(null);
            }

            if (this.question.invalid) {
                this.question.invalid = false;
            }

            this.value = moment(this.dateValue.value).format(this.dateFormat);
            this.valueChange.emit(this.value);
            this.action.emit(null);
        }
    }
}
